import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";
import { useSettings, buildWhatsAppLink } from "@/context/SettingsContext";

export default function FinalCTA() {
  const { settings } = useSettings();
  return (
    <section className="relative py-28 md:py-36 bg-[#0F0F0F] overflow-hidden grain" data-testid="final-cta-section">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] rounded-full bg-[#D4AF37]/10 blur-[120px]" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="relative max-w-3xl mx-auto px-5 md:px-10 text-center"
      >
        <div className="text-[0.7rem] tracking-[0.32em] uppercase text-[#D4AF37] font-semibold mb-6" data-testid="final-cta-eyebrow">
          {settings?.final_cta_eyebrow}
        </div>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-tight" data-testid="final-cta-headline">
          {settings?.final_cta_headline}
        </h2>
        <p className="text-white/70 mt-6 text-lg max-w-xl mx-auto" data-testid="final-cta-text">
          {settings?.final_cta_text}
        </p>
        <div className="mt-9 flex justify-center">
          <a
            href={buildWhatsAppLink(settings)}
            target="_blank"
            rel="noreferrer"
            className="btn-whatsapp text-base"
            data-testid="final-cta-whatsapp-button"
          >
            <MessageCircle className="w-5 h-5" />
            {settings?.final_cta_button_text || "Chat on WhatsApp"}
          </a>
        </div>
        <p className="text-white/45 text-sm mt-5" data-testid="final-cta-number">
          {settings?.whatsapp_number}
        </p>
      </motion.div>
    </section>
  );
}
